import { Linkedin, Instagram } from "lucide-react";
import { Logo, scrollToSection } from "./Reveal";

const Footer = () => (
  <footer className="border-t border-white/5 bg-obsidian py-12" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
      <div className="flex items-center gap-3">
        <Logo size={36} />
        <div>
          <p className="font-heading font-extrabold uppercase tracking-wide">Yassine Abou</p>
          <p className="text-xs text-slate-500">Préparation mentale & accompagnement des jeunes</p>
        </div>
      </div>
      <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-400">
        {[
          ["#methode", "Méthode"],
          ["#accompagnement", "Accompagnement"],
          ["#qui-suis-je", "Mon expertise"],
          ["#temoignages", "Témoignages"],
          ["#contact", "Contact"],
        ].map(([hash, label]) => (
          <a
            key={hash}
            href={hash}
            data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
            onClick={(e) => { e.preventDefault(); scrollToSection(hash); }}
            className="hover:text-white transition-colors duration-200"
          >
            {label}
          </a>
        ))}
        <a
          href="https://boussole.yassineabou.fr"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-link-boussole"
          className="text-gold font-semibold hover:text-amber-300 transition-colors duration-200"
        >
          Boussole — l'application
        </a>
        <a
          href="/ressources"
          data-testid="footer-link-ressources"
          className="hover:text-white transition-colors duration-200"
        >
          Ressources
        </a>
        <a
          href="/cgv"
          data-testid="footer-link-cgv"
          className="hover:text-white transition-colors duration-200"
        >
          CGV
        </a>
      </nav>
      <div className="flex items-center gap-3">
        <a
          href="https://www.linkedin.com/in/yassine-abou-24253288/"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-link-linkedin"
          aria-label="LinkedIn de Yassine Abou"
          className="flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-slate-300 hover:border-ember hover:text-white transition-colors duration-200"
        >
          <Linkedin size={16} />
        </a>
        <a
          href="https://www.instagram.com/karatemixfullcontact9194"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-link-instagram"
          aria-label="Instagram de Yassine Abou"
          className="flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-slate-300 hover:border-ember hover:text-white transition-colors duration-200"
        >
          <Instagram size={16} />
        </a>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-8 pt-6 border-t border-white/5">
      <p className="text-xs text-slate-600">© 2026 Yassine Abou — Tous droits réservés.</p>
    </div>
  </footer>
);

export default Footer;
